var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-nowrap text-center"},[_c('span',{staticClass:"align-text-top text-capitalize"},[_vm._v(" "+_vm._s(_vm.value ? _vm.value.fullName : "-")+" ")]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }